import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {VakdashboardNewFacade} from '../../state/vakdashboard/vakdashboard.facade';

@Component({
  selector: 'app-vakdashboard-table-row',
  templateUrl: './vakdashboard-table-row.component.html',
  styleUrls: ['./vakdashboard-table-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VakdashboardTableRowComponent implements OnInit {

  constructor(store: VakdashboardNewFacade) { }

  ngOnInit(): void {
  }

}
